
const initialState = {
    loading: false,
    newPass: false,
    error: false,
    settingsListing:[],
    settingsDetail:null
  };
  
  const settingsReducer = (state = initialState, action) => {
    // console.log("settings  reducers------", state,action);
   switch (action.type) {
     case "ADD_SETTINGS_REQUEST":
       return {
         ...state,
         loading: true,
       };
     case "ADD_SETTINGS_SUCCESS":
       return {
        ...state,
         loading: false,
         newPass: true,
         error: false,
       };
     case "ADD_SETTINGS_FAILED":
       return {
        ...state,
         loading: false,
         newPass: false,
         error: true,
       };

       case "GET_SETTINGS_REQUEST":
        return {
          ...state,
          loading: true,
        };
      case "GET_SETTINGS_REQUEST_FAILED":
        return {
          ...state,
          error: true,
        };
      case "GET_SETTINGS_REQUEST_SUCCESS":
        return {
          ...state,
          settingsListing: action.payload,
          loading:false,
        };

      case "GOT_SETTINGS_DETAIL":  
      return {
        ...state,
        settingsDetail: action.payload,
      };
     default:
       return state;
   }
  };
  
  export default settingsReducer;
  